import React, { useMemo, useState } from 'react';
import WorkOrderTable from '../WorkOrderTable';
import {
	BUYER_WO_FILTERS_ORDER,
	getWorkOrderArchivalKey,
	INTERNAL_SERVICE_TEAM_WO_FILTERS_ORDER,
	PAYING_SUPPLIER_WO_FILTER_ORDER,
	THIRD_PARTY_SUPPLIER_WO_FILTERS_ORDER,
} from '../../utils/WorkOrderUtils';
import { useParams, withRouter } from 'react-router';
import WorkOrderFiltersWrapper from '../work_order_filters_wrapper/WorkOrderFiltersWrapper';
import { withUserType } from '../withUserType';
import { connect } from 'react-redux';
import { isBuyerOrInternalTech } from '../../utils/AuthUtils';
import { withCurrentUser } from '../../hooks/withCurrentUser';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { SUBCONTRACTED_FILTERS } from '../WorkOrderTable/config/subcontracted';
import { ASSIGNED_FILTERS } from '../WorkOrderTable/config/assigned';
import { ACTIVE_WORK_ORDER_TAB_FILTERS } from '../WorkOrderTable/config/tabFilters/tabFilters';
import {
	isSupplierPayingCustomer,
	nullSafeGet,
	nullSafeGetOrElse,
	nullSafeGetWithZero,
} from '../../utils/DataAccessUtils';
import { selectViewById } from '../../selectors/viewSelector';

function WorkOrdersViewPage({ currentUser, userType, selectedView }) {
	const isBuyer = userType === ROLE_TYPES.BUYER;
	const isBuyerOrInternalTeam = isBuyerOrInternalTech(currentUser);

	const filterConfig = useMemo(() => {
		if (isBuyer) {
			return { filters: BUYER_WO_FILTERS_ORDER };
		}
		return {
			...(!isBuyerOrInternalTeam && { subContractedFilters: SUBCONTRACTED_FILTERS(currentUser) }),
			assignedFilters: ASSIGNED_FILTERS(currentUser),
			tabFilters: ACTIVE_WORK_ORDER_TAB_FILTERS,
			filters: isBuyerOrInternalTeam
				? INTERNAL_SERVICE_TEAM_WO_FILTERS_ORDER
				: isSupplierPayingCustomer(currentUser)
				? PAYING_SUPPLIER_WO_FILTER_ORDER
				: THIRD_PARTY_SUPPLIER_WO_FILTERS_ORDER,
		};
	}, []);

	const preAppliedFilters = useMemo(() => {
		const archivalKey = getWorkOrderArchivalKey(currentUser);
		const archivalValue = nullSafeGetWithZero(`filterValue.${archivalKey}`, selectedView);
		if (archivalValue != null) {
			return { [archivalKey]: archivalValue };
		}
		return {};
	}, [currentUser, selectedView]);

	return (
		<WorkOrderFiltersWrapper view={selectedView} key={nullSafeGet('id', selectedView)}>
			{(defaultFilters, defaultSorting) => (
				<WorkOrderTable
					handleQueryParams
					filterConfig={filterConfig}
					initialFilters={defaultFilters}
					initialSorting={defaultSorting}
					preAppliedFilters={preAppliedFilters}
				/>
			)}
		</WorkOrderFiltersWrapper>
	);
}

const mapStateToProps = (state, ownProps) => ({
	selectedView: selectViewById(state, nullSafeGetOrElse('viewId', ownProps.match.params, null)),
});

const mapDispatchToProps = (dispatch, ownProps) => ({});

export default withRouter(
	withCurrentUser(withUserType(connect(mapStateToProps, mapDispatchToProps)(WorkOrdersViewPage)))
);
